import React, { createContext, useState } from "react";

export const AuthContext = createContext();

const AuthContextProvider = (props) => {
  const [authenticatedUser, setAuthenticatedUser] = useState({
    auth_state: 0,
    name: "user",
  });

  const [uid, setUid] = useState("");

  const updateAuthenticatedUser = (newUser) => {
    setAuthenticatedUser(newUser);
  };

  const updateUid = (newId) => {
    setUid(newId);
  };

  return (
    <AuthContext.Provider
      value={{ authenticatedUser, uid, updateAuthenticatedUser, updateUid }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
